export default axiosInstance => ({
  /**
   * post Values csv
   * @return {Promise} retour axios
   */
  async importMappingsCsv(params) {
    let formData = new FormData();
    formData.append("file", params);
    return await axiosInstance.post("/mapping_categories/import", formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  },

  /**
   * Downloads the list of Mirakl values in csv format
   * @return {Promise} retour axios
   */
  async downloadMappingsAsCsv() {
    return await axiosInstance.get("/mapping_categories/export");
  }
});
